import Package from './pages/Package';

export default Package;
